export const CloseIcon = () => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2331_46107)">
        <path d="M6.99995 6.80653L11.5566 2.25L12.25 2.94342L7.69337 7.49995L12.25 12.0566L11.5566 12.75L6.99995 8.19347L2.44342 12.75L1.75 12.0566L6.30653 7.49995L1.75 2.94352L2.44342 2.2501L6.99995 6.80653Z" />
      </g>
      <defs>
        <clipPath id="clip0_2331_46107">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
